// utils/timeUtils.ts
// 時刻関連共通ユーティリティ

// 30分刻時刻の選択肢（0:00 〜 23:30）
export const timeSlotOptions: { value: string; label: string }[] = [];
for (let h = 0; h < 24; h++) {
  for (let m = 0; m < 60; m += 30) {
    const label = `${h}:${m.toString().padStart(2, '0')}`;
    timeSlotOptions.push({ value: label, label });
  }
}

// 時刻を±1h調整ヘルパー（折り返しあり）
export const adjustOneHour = (time: string, offset: 1 | -1): string => {
  const [h, m] = time.split(':').map(Number);
  let totalMinutes = h * 60 + m + offset * 60;
  if (totalMinutes < 0) totalMinutes += 24 * 60;
  totalMinutes %= 24 * 60;
  return `${Math.floor(totalMinutes / 60)}:${(totalMinutes % 60).toString().padStart(2, '0')}`;
};

// 時刻に1時間加算
export const addOneHour = (time: string): string => adjustOneHour(time, 1);

// 時刻から1時間減算
export const subtractOneHour = (time: string): string => adjustOneHour(time, -1);
